export default {
  'invoiceNoteItems.label.items': 'Total Items',
  'invoiceNoteItems.label.insurance': 'Total Insurance',
  'invoiceNoteItems.label.freight': 'Total Freight',
  'invoiceNoteItems.label.expenses': 'Total Expenses',
  'invoiceNoteItems.label.discount': 'Total Discount',
  'invoiceNoteItems.label.grade': 'Total Grade',
  'invoiceNoteItems.label.codeServices': 'Code Services',
  'invoiceNoteItems.label.deductioValue': 'Deduction Value',
  'invoiceNoteItems.label.conditionedDiscount': 'Conditioned Discount',
  'invoiceNoteItems.label.unconditionalDiscount': 'Unconditional Discount',
  'invoiceNoteItems.label.totalAmount': 'Total Amount',

  'invoiceNoteItems.column.internalCode': 'Internal Code',
  'invoiceNoteItems.column.description': 'Description',
  'invoiceNoteItems.column.cfop': 'CFOP',
  'invoiceNoteItems.column.ncm': 'NCM',
  'invoiceNoteItems.column.itemNumber': 'Item Number',
  'invoiceNoteItems.column.qty': 'Qty.',
  'invoiceNoteItems.column.unitPrice': 'Unit Price',
  'invoiceNoteItems.column.discount': 'Discount',
  'invoiceNoteItems.column.totalAmount': 'Total Amount',
  'invoiceNoteItems.column.rate': 'Aliquot',

  'invoiceNoteItems.button.selectPart': 'Select a Part',
  'invoiceNoteItems.button.updateTaxes': 'Update Taxes',
  'invoiceNoteItems.button.selectService': 'Select a Service',
  'invoiceNoteItems.button.deleteSelectedServices': 'Delete selected services',
  'invoiceNoteItems.button.includeService': 'Include Service',
};
